<template>
  <div class="panel" :style="{ '--color': '#FF6637' }">
	  <!-- 底部子路由切换 -->
    <div class="R">
      <router-view></router-view>
    </div>
    <!-- 左侧面板选择 -->
    <left></left>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import left from "@/views/mechanism/children/left";
export default {
  name: "panel",
  components: {
    left,
  },
  // 定义属性
  data() {
	  return {
	};
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 方法集合
	methods: {

  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped lang="scss">
.panel {
  display: flex;
  justify-content: center;
  flex-direction: row-reverse;
  margin-top: 10px;
}
// .Top-Style {
//   width: 16.5rem;
//   height: 0.6rem;
//   margin-left: 8px;
//   background: white;
//   border-radius: 10px;
// }
.R {
  width: 16.5rem;
  margin-left: 8px;
  margin-bottom: 20px
}
</style>
